module.exports = __webpack_public_path__ + "fonts/Vonnes-MediumCompItalic.e2892d2d.otf";